export default "__VITE_ASSET__29348323__"